import React, { useState, useContext, useEffect } from "react";
import PixabayPics from "./PixabayPics";
import PremiumPics from "./PremiumImages.component";
import ImageUploader from "./ImageUploader";
import TickerContext from "../../../../context/ticker";
import ProjectContext from "../../../../context/ProjectContext";

export const ImagesWrapper = (props) => {
  const { Goto } = useContext(TickerContext);
  const {setDeafultLoader} = useContext(ProjectContext);

  const [isPixaBay, setIsPixaBay] = useState(true);
  const [imageUploads, setimageUploads] = useState(false);
  const [isPremium, setIsPremium] = useState(false);

  const SetPixabay = (e) => {
    setIsPixaBay(true);
    setIsPremium(false);
    setimageUploads(false);
  };

  const SetPremium = (e) => {
    setIsPixaBay(false);
    setIsPremium(true);
    setimageUploads(false);
  };

  const myUploads = (e) => {
    setIsPixaBay(false);
    setIsPremium(false);
    setimageUploads(true);
  };

  useEffect(() => {
    if (Goto.innerMenu != null) {
      if (Goto.innerMenu == "img") {
        SetPixabay();
      }
    }
  }, [Goto]);

  return (
    <div id="imagesWrapper" className="innerWrapperPanel">
      <div className="templatesWrapper2">
        <div className="divLabel mb-3">Photos</div>

        <div className="tabs mb-2">
          <div className="p2">
            <div
              className={"tabButton" + (isPixaBay ? " activeTab" : "")}
              onClick={SetPixabay}
            >
              Free Stock
            </div>
            {/* <div
              className={
                "tabButton" + (!isPixaBay && !imageUploads ? " activeTab" : "")
              }
              onClick={SetPremium}
            >
              Premium
            </div> */}
            <div
              className={
                "tabButton" + (!isPixaBay && !isPremium ? " activeTab" : "")
              }
              onClick={myUploads}
            >
              Uploads
            </div>
          </div>
        </div>

        {isPixaBay && <PixabayPics />}

        {isPremium && <PremiumPics />}

        {imageUploads && <ImageUploader setDeafultLoader={setDeafultLoader} />}
      </div>
    </div>
  );
};
export default ImagesWrapper;
